export default "__VITE_ASSET__0U77qYJM__"